import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { Subject, throwError } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginViewModel } from '../../../../../shared/models/general';
import { FusionAuthService } from '../../../../../shared/services/fusion-auth';
import {FormControl} from "@angular/forms";

@Component({
    selector: 'app-signature-unsing-dialog',
    templateUrl: './signature-unsing-dialog.component.html',
    styleUrls: ['./signature-unsing-dialog.component.scss']
})
export class SignatureUnsingDialogComponent implements OnInit, OnDestroy {
    @ViewChild('popupComponent', { static: true }) public popupComponent?: DxPopupComponent;
    @Input() public popupVisible = false;
    @Output() public closeEvent = new EventEmitter();
    public username = '';
    public password = '';
    public passwordControl: any;
    private onDestroy$: Subject<void> = new Subject<void>();

    constructor(private fusionAuthService: FusionAuthService) {
    }

    public close() {
        this.closeEvent.emit(false);
    }

    public clear() {
        this.username = this.Username;
        this.password = '';
    }

    public get Username() {
        return this.fusionAuthService.Profile !== undefined && this.fusionAuthService.Profile !== null
            ? this.fusionAuthService.Profile.email : 'You Are Not Logged In';
    }

    public ngOnInit(): void {
        this.username = this.Username;
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.popupVisible && changes.popupVisible.currentValue) {
            if (this.passwordControl === undefined) {
                setTimeout(() => {
                    this.passwordControl?.instance().focus();
                }, 500);
            } else {
                setTimeout(() => {
                    this.passwordControl?.instance().focus();
                }, 500);
            }
        }
    }

    public ready(e: any) {
        this.passwordControl = e.component;
    }

    public sign() {
        this.fusionAuthService.login({
            loginId: this.fusionAuthService.Profile.email,
            password: this.password,
          applicationId: ''
        } as LoginViewModel, true)
            .pipe(takeUntil(this.onDestroy$)).subscribe(() => {
                this.closeEvent.emit(true);
                this.clear();
            }, (e) => {
                notify('Invalid password.', 'error');
                return throwError(e);
            });
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next(); this.onDestroy$.complete()
    }
}
